module.exports = __webpack_public_path__ + "static/media/logout.6a20b4c2.svg";